import { ReactNode } from "react";

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  bottomContent?: ReactNode;
}

const PageTitle = ({ title, subtitle, bottomContent }: Props) => {
  return (
    <div className="px-8 pt-4.5">
      <div className="flex flex-col gap-2">
        <span className="typo-headline-lg">{title}</span>
        {subtitle && (
          <p className="typo-title-lg text-typography-secondary">{subtitle}</p>
        )}
      </div>
      {bottomContent && <div className="mt-5.5">{bottomContent}</div>}
    </div>
  );
};

export default PageTitle;
